<template>
  <a-modal v-model.trim="visible" :title="$t('租赁_录入运输信息')" width="800px" :okText="$t('confirm')" @ok="submit">
    <a-form-model :model="editForm" layout="vertical" :rules="validateRules" ref="editForm">
      <a-row :gutter="20">
        <a-col :span="12">
          <a-form-model-item :label="$t('transportationType')" prop="SHIP_TYPE">
            <a-radio-group v-model.trim="editForm.SHIP_TYPE">
              <template v-for="item in transTypeOptions">
                <a-radio :value="item.code">{{ $dt(item, 'text') }}</a-radio>
              </template>
            </a-radio-group>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item v-if="!editForm.FLOW_ID" :label="$t('uploadFiles')" prop="GUID_CODES">
            <dol-upload :paramsData="uploadParams" :text="$t('uploadFiles')" serverType="2009" v-model.trim="editForm.GUID_CODES"/>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item
            :label="(editForm.SHIP_TYPE === '20061001' || editForm.SHIP_TYPE === '20061003') ? $t('BLNO') : $t('sweepNumber')"
            prop="SHIP_CODE"
          >
            <a-input v-model.trim="editForm.SHIP_CODE"/>
          </a-form-model-item>
        </a-col>
        <a-col v-if="editForm.SHIP_TYPE === '20061001' || editForm.SHIP_TYPE === '20061003'" :span="12">
          <a-form-model-item :label="$t('vesselVoyage')" prop="SHIP_NAME">
            <a-auto-complete v-model="editForm.SHIP_NAME" @change="getShipNameList">
              <template #dataSource>
                <a-select-opt-group v-if="shipOptions.length > 0">
                  <template #label>
                    <a-pagination
                        style="position: absolute;right: 4px"
                        v-model.trim="shipPageNumber"
                        :total="shipTotal"
                        show-less-items
                        @change="getShipNameList"
                    />
                  </template>
                  <a-select-option v-for="name in shipOptions" :key="name">
                    {{ name }}
                  </a-select-option>
                </a-select-opt-group>
              </template>
            </a-auto-complete>
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <div class="apply-return-order">
      <a-collapse class="apply-return-order-box" v-model="activeKey" expandIconPosition="right">
        <template v-for="order in orderList">
          <a-collapse-panel :key="order.XB_SHEET_CODE">
            <template #header>
              <div class="apply-return-order-header">
                <span class="apply-return-order-header-title">{{ $t('orderID') }}：{{ order.XB_SHEET_CODE }}</span>
                <span class="apply-return-order-header-chose">（{{ $t('通用_已选') }} {{ order.BOX_OPTIONS.length }}）</span>
              </div>
            </template>
            <a-row :gutter="[20, 20]">
              <template v-for="box in order.BOX_OPTIONS">
                <a-col :span="8"><a-tag>{{box.BOX_CODE}}</a-tag></a-col>
              </template>
            </a-row>
          </a-collapse-panel>
        </template>
      </a-collapse>
    </div>
  </a-modal>
</template>

<script>
export default {
  name: 'transport-info-modal',
  mixins: [],
  components: {},
  data () {
    return {
      visible: false,
      boxList: [],
      activeKey: [],

      editForm: {},
      loading: false,

      // 备选项
      transTypeOptions: [],
      shipOptions: [],
      shipPageNumber: 1,
      shipTotal: 0,
    };
  },
  computed: {
    uploadParams () {
      return {
        "SYS_TYPE": "20011003",
        "TARGET_CATE": "20021020",
        "TARGET_TYPE": "20071007",
        "TARGET_ID": "",
        "GUID_CODE": ""
      };
    },
    validateRules(){
      const rules = {};
      rules.SHIP_TYPE = [{required: true, message: this.$t('pleaseSelectAShippingType'), trigger: ['blur','change']}];
      return rules;
    },

    // 显示数据
    orderList(){
      const orderList = [], orderMap = {};
      this.boxList.forEach(box => {
        if(!orderMap[box.XB_SHEET_CODE]){
          orderMap[box.XB_SHEET_CODE] = {
            XB_SHEET_CODE: box.XB_SHEET_CODE,
            BOX_OPTIONS: [],
          }
          orderList.push(orderMap[box.XB_SHEET_CODE])
        }
        orderMap[box.XB_SHEET_CODE].BOX_OPTIONS.push(box);
      });
      return orderList;
    },
  },
  methods: {
    open (boxList) {
      this.boxList = boxList;
      this.activeKey = this.orderList.map(item => item.XB_SHEET_CODE);
      const editForm = {};
      if(boxList[0]){
        editForm.SHIP_TYPE = String(boxList[0].TRANS_WAY);
        editForm.SHIP_NAME = boxList[0].SHIP_NN;
      }
      this.editForm = editForm;
      this.visible = true;
    },
    // 查询船名航次
    getShipNameList (value) {
      if (!value) return true;
      let condition = [
        {
          'GET_HEAD': [
            {
              'GET_METHOD': 1,
              'GET_TABLE': 'GM_INPUT_PROMPT',
              'BEGIN_ROW_NO': this.shipPageNumber,
              'GET_ROW_CNT': 10,
              'SORT_FIELD': 'UPDATE_DATE',
            }],
          'GET_FILTER': [
            { 'FILTER_FIELD': 'PROMPT_CONTENT', 'FILTER_TYPE': 4, 'FILTER_VALUE1': value, 'FILTER_VALUE2': '' },
            { 'FILTER_FIELD': 'INPUT_TYPE', 'FILTER_TYPE': '1', 'FILTER_VALUE1': 0, 'FILTER_VALUE2': '' },
            { 'FILTER_FIELD': 'STATUS', 'FILTER_TYPE': '1', 'FILTER_VALUE1': 1, 'FILTER_VALUE2': '' },
          ],
        }];
      this.$h5Api({
        type: '1001',
        data: condition,
        showMessage: false,
        loading: false,
      }).then(data => {
        let list = [];
        data.data['DATA_LIST'].forEach(item => {
          list.push(item.PROMPT_CONTENT);
        });
        this.shipOptions = list;
        this.shipTotal = list.length;
      });
    },
    submit(){
      this.$refs.editForm.validate(v => {
        if(!v){
          return false;
        }

        const submitData = [];
        this.orderList.forEach(order => {
          const data = {
            OPER_TYPE: '0', // 新增
            SHIP_TYPE: this.editForm.SHIP_TYPE,
            SHIP_CODE: this.editForm.SHIP_CODE,
            SHIP_NAME: this.editForm.SHIP_NAME,
            SHIP_DETAIL: [],
          };
          order.BOX_OPTIONS.forEach(box => {
            data.SHIP_DETAIL.push({
              FLOW_ID: box.BOX_FLOW_ID,
              BOX_ID: box.BOX_ID,
              GUID_CODES: this.editForm.GUID_CODES ? this.editForm.GUID_CODES.map(val => val.GUID_CODE).join(',') : '',
            })
          });
          submitData.push(data);
        });

        this.loading = true;
        this.$h5Api({
          type: '4030',
          data: submitData,
        }).then(({data}) => {
          this.visible = false;
          this.$message.info(String(this.$t('operateSuccessfully')));
          this.$emit('refresh');
        }).finally(() => {
          this.loading = false;
        });
      })
    }
  },
  created () {
    // 运输类型备选项
    this.$dict(2006, null, { labelField: 'text', valueField: 'DIC_CODE' }).then(data => {
      this.transTypeOptions = data;
    });
  },
};
</script>

<style scoped lang="scss">
.apply-return-order {
  .apply-return-order-box {
    margin-top: 16px;
  }

  .apply-return-order-header {
    display: flex;
    align-items: center;

    .apply-return-order-header-title {
      margin-left: 8px;
      font-weight: 600;
      color: #333333;
    }

    .apply-return-order-header-chose {
      color: #666666;
      font-size: 12px;
    }
  }
}
</style>